// URL信息获取服务
class UrlInfoService {
  constructor() {
    // 常见网站的缩写和信息映射
    this.siteMap = {
      'github.com': { abbr: 'GH', name: 'GitHub', color: '#333', icon: 'mdi-github' },
      'stackoverflow.com': { abbr: 'SO', name: 'Stack Overflow', color: '#f48024', icon: 'mdi-stack-overflow' },
      'google.com': { abbr: 'Google', name: 'Google', color: '#4285f4', icon: 'mdi-google' },
      'youtube.com': { abbr: 'YT', name: 'YouTube', color: '#ff0000', icon: 'mdi-youtube' },
      'twitter.com': { abbr: 'Twitter', name: 'Twitter', color: '#1da1f2', icon: 'mdi-twitter' },
      'x.com': { abbr: 'X', name: 'X (Twitter)', color: '#000000', icon: 'mdi-twitter' },
      'facebook.com': { abbr: 'FB', name: 'Facebook', color: '#1877f2', icon: 'mdi-facebook' },
      'linkedin.com': { abbr: 'LI', name: 'LinkedIn', color: '#0077b5', icon: 'mdi-linkedin' },
      'reddit.com': { abbr: 'Reddit', name: 'Reddit', color: '#ff4500', icon: 'mdi-reddit' },
      'medium.com': { abbr: 'Medium', name: 'Medium', color: '#00ab6c', icon: 'mdi-medium' },
      'dev.to': { abbr: 'Dev', name: 'Dev Community', color: '#0a0a0a', icon: 'mdi-dev-to' },
      'codepen.io': { abbr: 'CodePen', name: 'CodePen', color: '#000000', icon: 'mdi-codepen' },
      'jsfiddle.net': { abbr: 'JSFiddle', name: 'JSFiddle', color: '#4679bd', icon: 'mdi-code-braces' },
      'codesandbox.io': { abbr: 'CodeSandbox', name: 'CodeSandbox', color: '#000000', icon: 'mdi-code-braces-box' },
      'npmjs.com': { abbr: 'NPM', name: 'NPM Registry', color: '#cb3837', icon: 'mdi-npm' },
      'mozilla.org': { abbr: 'MDN', name: 'MDN Web Docs', color: '#000000', icon: 'mdi-firefox' },
      'w3schools.com': { abbr: 'W3S', name: 'W3Schools', color: '#04aa6d', icon: 'mdi-school' },
      'css-tricks.com': { abbr: 'CSS', name: 'CSS-Tricks', color: '#ff6347', icon: 'mdi-language-css3' },
      'freecodecamp.org': { abbr: 'FCC', name: 'freeCodeCamp', color: '#0a0a23', icon: 'mdi-fire' },
      'hackernews.com': { abbr: 'HN', name: 'Hacker News', color: '#ff6600', icon: 'mdi-newspaper' },
      'news.ycombinator.com': { abbr: 'HN', name: 'Hacker News', color: '#ff6600', icon: 'mdi-newspaper' },
      'dribbble.com': { abbr: 'Dribbble', name: 'Dribbble', color: '#ea4c89', icon: 'mdi-basketball' },
      'behance.net': { abbr: 'Behance', name: 'Behance', color: '#1769ff', icon: 'mdi-adobe' },
      'figma.com': { abbr: 'Figma', name: 'Figma', color: '#f24e1e', icon: 'mdi-vector-square' },
      'notion.so': { abbr: 'Notion', name: 'Notion', color: '#000000', icon: 'mdi-note-text' },
      'trello.com': { abbr: 'Trello', name: 'Trello', color: '#0079bf', icon: 'mdi-trello' },
      'slack.com': { abbr: 'Slack', name: 'Slack', color: '#4a154b', icon: 'mdi-slack' },
      'discord.com': { abbr: 'Discord', name: 'Discord', color: '#5865f2', icon: 'mdi-discord' },
      'zoom.us': { abbr: 'Zoom', name: 'Zoom', color: '#2d8cff', icon: 'mdi-video' },
      'microsoft.com': { abbr: 'MS', name: 'Microsoft', color: '#00a1f1', icon: 'mdi-microsoft' },
      'apple.com': { abbr: 'Apple', name: 'Apple', color: '#000000', icon: 'mdi-apple' },
      'amazon.com': { abbr: 'Amazon', name: 'Amazon', color: '#ff9900', icon: 'mdi-amazon' },
      'netflix.com': { abbr: 'Netflix', name: 'Netflix', color: '#e50914', icon: 'mdi-netflix' },
      'spotify.com': { abbr: 'Spotify', name: 'Spotify', color: '#1db954', icon: 'mdi-spotify' },
      'twitch.tv': { abbr: 'Twitch', name: 'Twitch', color: '#9146ff', icon: 'mdi-twitch' },
      'instagram.com': { abbr: 'IG', name: 'Instagram', color: '#e4405f', icon: 'mdi-instagram' },
      'tiktok.com': { abbr: 'TikTok', name: 'TikTok', color: '#000000', icon: 'mdi-music-note' },
      'pinterest.com': { abbr: 'Pinterest', name: 'Pinterest', color: '#bd081c', icon: 'mdi-pinterest' },
      'whatsapp.com': { abbr: 'WhatsApp', name: 'WhatsApp', color: '#25d366', icon: 'mdi-whatsapp' },
      'telegram.org': { abbr: 'Telegram', name: 'Telegram', color: '#0088cc', icon: 'mdi-telegram' },
      'dropbox.com': { abbr: 'Dropbox', name: 'Dropbox', color: '#0061ff', icon: 'mdi-dropbox' },
      'drive.google.com': { abbr: 'GDrive', name: 'Google Drive', color: '#4285f4', icon: 'mdi-google-drive' },
      'onedrive.live.com': { abbr: 'OneDrive', name: 'OneDrive', color: '#0078d4', icon: 'mdi-microsoft-onedrive' },
      'icloud.com': { abbr: 'iCloud', name: 'iCloud', color: '#007aff', icon: 'mdi-apple-icloud' }
    }
  }

  // 解析URL并获取网站信息
  async getUrlInfo(url) {
    try {
      const urlObj = new URL(url)
      const hostname = urlObj.hostname.replace('www.', '')
      
      // 查找已知网站
      const siteInfo = this.siteMap[hostname]
      
      if (siteInfo) {
        return {
          abbr: siteInfo.abbr,
          title: this.generateTitle(urlObj, siteInfo.name),
          domain: hostname,
          color: siteInfo.color,
          icon: siteInfo.icon,
          favicon: `https://www.google.com/s2/favicons?domain=${hostname}&sz=32`
        }
      }

      // 未知网站，生成信息
      return this.generateUnknownSiteInfo(urlObj)
      
    } catch (error) {
      throw new Error('无效的URL格式')
    }
  }

  // 为未知网站生成信息
  generateUnknownSiteInfo(urlObj) {
    const hostname = urlObj.hostname.replace('www.', '')
    const parts = hostname.split('.')
    
    // 生成缩写
    let abbr
    if (parts.length >= 2) {
      const mainPart = parts[0]
      if (mainPart.length <= 3) {
        abbr = mainPart.toUpperCase()
      } else {
        abbr = mainPart.substring(0, 2).toUpperCase()
      }
    } else {
      abbr = hostname.substring(0, 3).toUpperCase()
    }

    // 生成标题
    let title = this.capitalizeFirst(parts[0])
    if (urlObj.pathname !== '/') {
      const pathParts = urlObj.pathname.split('/').filter(p => p)
      if (pathParts.length > 0) {
        const lastPart = pathParts[pathParts.length - 1]
        title = this.formatPathTitle(lastPart)
      }
    }

    return {
      abbr,
      title,
      domain: hostname,
      color: this.generateColor(hostname),
      favicon: `https://www.google.com/s2/favicons?domain=${hostname}&sz=32`
    }
  }

  // 生成标题
  generateTitle(urlObj, siteName) {
    if (urlObj.pathname === '/') {
      return siteName
    }

    const pathParts = urlObj.pathname.split('/').filter(p => p)
    if (pathParts.length === 0) {
      return siteName
    }

    const lastPart = pathParts[pathParts.length - 1]
    return this.formatPathTitle(lastPart)
  }

  // 格式化路径标题
  formatPathTitle(pathPart) {
    return pathPart
      .replace(/[-_]/g, ' ')
      .replace(/\.(html|php|jsp|asp)$/i, '')
      .split(' ')
      .map(word => this.capitalizeFirst(word))
      .join(' ')
  }

  // 首字母大写
  capitalizeFirst(str) {
    if (!str) return ''
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }

  // 为域名生成颜色
  generateColor(domain) {
    let hash = 0
    for (let i = 0; i < domain.length; i++) {
      hash = domain.charCodeAt(i) + ((hash << 5) - hash)
    }
    
    const hue = Math.abs(hash) % 360
    return `hsl(${hue}, 60%, 50%)`
  }

  // 获取常用网站列表
  getPopularSites() {
    const popular = [
      'github.com',
      'stackoverflow.com',
      'mozilla.org',
      'npmjs.com',
      'dev.to',
      'youtube.com',
      'google.com',
      'twitter.com',
      'linkedin.com',
      'medium.com',
      'codepen.io',
      'codesandbox.io'
    ]

    return popular.map(domain => {
      const siteInfo = this.siteMap[domain]
      return {
        abbr: siteInfo.abbr,
        href: `https://${domain}`,
        title: siteInfo.name,
        domain,
        color: siteInfo.color,
        icon: siteInfo.icon
      }
    })
  }

  // 从剪贴板获取URL信息
  async getFromClipboard() {
    if (!navigator.clipboard || !navigator.clipboard.readText) {
      throw new Error('您的浏览器不支持剪贴板读取功能')
    }

    const clipboardText = await navigator.clipboard.readText()
    
    if (!clipboardText.trim()) {
      throw new Error('剪贴板为空')
    }

    // 尝试解析为URL
    let url
    try {
      url = new URL(clipboardText.trim())
    } catch {
      // 如果不是完整URL，尝试添加协议
      try {
        url = new URL('https://' + clipboardText.trim())
      } catch {
        throw new Error('剪贴板内容不是有效的URL')
      }
    }

    return this.getUrlInfo(url.href)
  }

  // 搜索网站
  searchSites(query) {
    if (!query) return []

    const lowerQuery = query.toLowerCase()
    const results = []

    Object.entries(this.siteMap).forEach(([domain, info]) => {
      if (
        domain.includes(lowerQuery) ||
        info.name.toLowerCase().includes(lowerQuery) ||
        info.abbr.toLowerCase().includes(lowerQuery)
      ) {
        results.push({
          abbr: info.abbr,
          href: `https://${domain}`,
          title: info.name,
          domain,
          color: info.color,
          icon: info.icon
        })
      }
    })

    return results.slice(0, 10) // 限制结果数量
  }
}

export default new UrlInfoService()
